import { isEmpty } from 'lodash'
import { FC, useEffect, useState } from 'react'
import viewQr from '../../../resources/images/viewQr.svg'
import { Col, notification, Row } from 'antd'
import CategoriesService from '../../../services/categories.service'
import { moneyFormat } from '../../../utils/stringUtils'
import { LocalStore } from '../../../utils/LocalStore'

interface Props {
    data: {
        type: string
        money: number
    } | null
    t: any
    history: any
    onClose: any
}

export const QrCodePayment: FC<Props> = ({ data, t, history, onClose }) => {
    const [dataQr, setDataQr] = useState<any>({})
    const currentProjectInfo = LocalStore.getInstance().read('currentProjectInfo') || {}
    const tenantConfig = currentProjectInfo.tenantConfig || {}
    const generalConfig = tenantConfig ? tenantConfig.generalConfig : {}

    useEffect(() => {
        CategoriesService.getQrWithAmount(data?.money, (err: any, res: any) => {
            if (!isEmpty(res)) {
                console.log('res',)
                setDataQr(res)
            } else {
                if (generalConfig?.enableCashCollectionRequest) {
                    const currentHref = window.location.href
                    onClose()
                    history.push({
                        pathname: '/cash-request',
                        search: `amount=${data?.money}`
                    })
                    if (currentHref?.includes('/cash-request')) {
                        window.location.reload()
                    }
                } else {
                    notification.error({
                        message: 'Tài khoản của quý khách hiện tại không nạp được tiền, vui lòng liên hệ CSKH để được xử lý.',
                    })
                }
            }
        })
    }, [data?.money, generalConfig?.enableCashCollectionRequest, history, onClose])

    return (
        <div>
            <div>
                {data?.money && Number(data?.money) >= 0 ? (
                    <Row
                        justify="space-between"
                        className="mb-3"
                    >
                        <Col className="text-grey-400">{t('deposit.money')}</Col>
                        <Col className=" text-base font-bold text-blue-primary">{moneyFormat(data?.money)}</Col>
                    </Row>
                ) : null}
                <Row justify="space-between">
                    <Col className="text-grey-400">{t('deposit.content')}</Col>
                    <Col>
                        {dataQr?.content}
                    </Col>
                </Row>
                <div className="custom-line-dash my-6"></div>
            </div>
            <div className="h-[308px] flex justify-center">
                {dataQr?.imageUrl && (
                    <div className="relative w-[300px]">
                        <img
                            alt="view-qrcode"
                            src={viewQr}
                            className="w-[300px]"
                        ></img>
                        <img
                            alt="qrcode"
                            src={dataQr?.imageUrl}
                            className="w-[250px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                        ></img>
                    </div>
                )}
            </div>
        </div>
    )
}
